import { ChangeEvent } from "react";
import { formatString } from "@format-string/core";
import { Box, MenuItem } from "@mui/material";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { useContextProdutor } from "src/Contexts/produtores/ProdutoresContext";
import { ICreateProdutor } from "src/Contexts/produtores/ProdutoresTypes";
import { AppTextField } from "src/Pages/components/AppFormComponents/AppTextField";
import { AutoCompleteFiliaisGeneric } from "src/Pages/components/AutoCompleted/AutoCompleteFiliais";
import { DividerCore } from "src/Pages/components/DividerCore/DividerCore";
import { handleFormatCep } from "src/shared/Utils/FormatCEP";
import { FormatRG } from "src/shared/Utils/FormatRG/FormatRG";
import { unidadesFederativas } from "src/shared/Utils/ListUFBR";

import { AutoCompleteGerenteAll } from "../../../../../components/AutoCompleted/AutoCompleteGerente";
import { AutoCompleteGrupoImposto } from "../../../../../components/AutoCompleted/AutoCompleteGrupoImposto";
import { AutoCompleteSupervisorAll } from "../../../../../components/AutoCompleted/AutoCompleteSupervisor";

import { UseGetCEPProducer } from "./hook/UseGetCEPProducer";

export const FormProducer = () => {
  const { idTable } = useConfigPageContext();
  const { valuesInputsProdutor, setValuesInputsProdutor } =
    useContextProdutor();

  UseGetCEPProducer();

  const handleChange =
    (
      prop: keyof ICreateProdutor,
      option?: "rg" | "phone" | "CPF_CNPJ" | "CEP"
    ) =>
      (event: ChangeEvent<HTMLInputElement>) => {
        if (option === "CEP") {
          setValuesInputsProdutor((prevEvent) => ({
            ...prevEvent,
            [prop]: handleFormatCep(event.target.value),
          }));
        } else if (option === "CPF_CNPJ") {
          if (valuesInputsProdutor.fisico_juridico === "fisica") {
            setValuesInputsProdutor((prevValue) => ({
              ...prevValue,
              [prop]: formatString({ value: event.target.value, type: "cpf" }),
            }));
          }
          if (valuesInputsProdutor.fisico_juridico === "juridica") {
            setValuesInputsProdutor((prevValue) => ({
              ...prevValue,
              [prop]: formatString({ value: event.target.value, type: "cnpj" }),
            }));
          }
        } else if (option === "phone") {
          setValuesInputsProdutor((prevValue) => ({
            ...prevValue,
            [prop]: formatString({ value: event.target.value, type: "phone" }),
          }));
        } else if (option === "rg") {
          setValuesInputsProdutor((prevValue) => ({
            ...prevValue,
            [prop]: FormatRG(event.target.value),
          }));
        } else {
          setValuesInputsProdutor((prevValue) => ({
            ...prevValue,
            [prop]: event.target.value,
          }));
        }
      };

  return (
    <>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
        <AppTextField
          label="Nome completo *"
          sxStyle={{ width: "270px", opacity: "", pointerEvents: "auto" }}
          variant="outlined"
          value={valuesInputsProdutor?.nome}
          onChange={handleChange("nome")}
          fullWidth
        />
        <AppTextField
          select
          defaultValue="ASSINATURA"
          id="Fisica | Juridica *"
          label="Fisica | Juridica"
          sxStyle={{ width: "120px", opacity: "", pointerEvents: "auto" }}
          variant="outlined"
          value={valuesInputsProdutor?.fisico_juridico}
          onChange={handleChange("fisico_juridico")}
        >
          <MenuItem value="fisica">Fisica</MenuItem>
          <MenuItem value="juridica">Juridica</MenuItem>
        </AppTextField>
        <AppTextField
          label="CPF/CNPJ"
          sxStyle={{ width: "200px", opacity: "", pointerEvents: "auto" }}
          variant="outlined"
          value={valuesInputsProdutor?.cpf_cnpj}
          onChange={handleChange("cpf_cnpj", "CPF_CNPJ")}
        />
        <AppTextField
          label="RG"
          sxStyle={{ width: "150px", opacity: "", pointerEvents: "auto" }}
          variant="outlined"
          value={valuesInputsProdutor?.rg}
          onChange={handleChange("rg", "rg")}
        />

        <AutoCompleteFiliaisGeneric
          label="Filial *"
          tamanho="200px"
          variant="outlined"
        />

        <AutoCompleteGrupoImposto
          label="Grupo de imposto *"
          tamanho="200px"
          variant="outlined"
        />

        <AppTextField
          select
          disabled={!!idTable}
          id="Função_Produtor"
          label="Função Produtor"
          sxStyle={{ width: "130px", opacity: "", pointerEvents: "auto" }}
          variant="outlined"
          value={valuesInputsProdutor?.funcao_produtor}
          onChange={handleChange("funcao_produtor")}
        >
          <MenuItem value="CORRETOR">Corretor</MenuItem>
          <MenuItem value="SUPERVISOR">Supervisor</MenuItem>
          <MenuItem value="GERENTE">Gerente</MenuItem>
        </AppTextField>

        <AppTextField
          select
          id="tipo_relatorio"
          label="Tipo Produtor"
          disabled={valuesInputsProdutor.funcao_produtor !== "CORRETOR"}
          sxStyle={{ width: "130px", opacity: "", pointerEvents: "auto" }}
          variant="outlined"
          value={valuesInputsProdutor?.tipo_produtor}
          onChange={handleChange("tipo_produtor")}
        >
          <MenuItem value="SALAO">Salão</MenuItem>
          <MenuItem value="REPASSE">Repasse</MenuItem>
          <MenuItem value="FREE_LANCE">Free lance</MenuItem>

          <MenuItem value="CONECTOR">Conector</MenuItem>
          <MenuItem value="ADMINISTRATIVO">Administrativo</MenuItem>
          <MenuItem value="INTERNO">Interno</MenuItem>
          <MenuItem value="HOME">Home</MenuItem>
          <MenuItem value="START">Start</MenuItem>
          <MenuItem value="MOVE">Move</MenuItem>
          <MenuItem value="MASTER">Master</MenuItem>
          <MenuItem value="SALAO_RUBY">Salão Ruby</MenuItem>
          <MenuItem value="SALAO_SAFIRA">Salão Safira</MenuItem>
          <MenuItem value="SALAO_DIAMANTE">Salão Diamante</MenuItem>
          <MenuItem value="GRADE_DF">Grade DF</MenuItem>
          <MenuItem value="GRADE_GO">Grade GO</MenuItem>
          <MenuItem value="GRADE_MT">Grade MT</MenuItem>
          <MenuItem value="GRADE_SP">Grade SP</MenuItem>
          <MenuItem value="SALAO_MG">Salão MG</MenuItem>
          <MenuItem value="EXTERNO_MG">Externo MG</MenuItem>
          <MenuItem value="SALAO_FORTALEZA">Salão Fortaleza</MenuItem>
          <MenuItem value="EXTERNO_FORTALEZA">Externo Fortaleza</MenuItem>
          <MenuItem value="SALAO_BELEM">Salão Belém</MenuItem>
          <MenuItem value="EXTERNO_BELEM">Externo Belém</MenuItem>
          <MenuItem value="SALAO_RECIFE">Salão Recife</MenuItem>
          <MenuItem value="EXTERNO_RECIFE">Externo Recife</MenuItem>
          <MenuItem value="EXTERNO_ESPECIAL_RJ">Externo Especial RJ</MenuItem>
          <MenuItem value="EP_1">EP 1</MenuItem>
          <MenuItem value="EP_2">EP 2</MenuItem>
        </AppTextField>


        <AutoCompleteSupervisorAll
          label="Supervisor"
          tamanho="250px"
          variant="outlined"
        />
        <AutoCompleteGerenteAll
          label="Gerente"
          tamanho="250px"
          variant="outlined"
        />
      </Box>

      <DividerCore title="Dados" />

      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
        <AppTextField
          label="Email Contato"
          sxStyle={{ width: "300px", opacity: "", pointerEvents: "auto" }}
          variant="outlined"
          value={valuesInputsProdutor?.email_contato}
          onChange={handleChange("email_contato")}
        />
        <AppTextField
          label="Telefone 1"
          sxStyle={{ width: "170px", opacity: "", pointerEvents: "auto" }}
          variant="outlined"
          value={valuesInputsProdutor?.telefone1}
          onChange={handleChange("telefone1", "phone")}
        />
        <AppTextField
          label="Telefone 2"
          sxStyle={{ width: "170px", opacity: "", pointerEvents: "auto" }}
          variant="outlined"
          type="telefone"
          value={valuesInputsProdutor?.telefone2}
          onChange={handleChange("telefone2", "phone")}
        />

        <AppTextField
          label="Data nascimento"
          sxStyle={{ width: "150px", opacity: "", pointerEvents: "auto" }}
          variant="outlined"
          type="date"
          value={valuesInputsProdutor?.data_nasc}
          onChange={handleChange("data_nasc")}
        />
        <AppTextField
          label="CEP"
          sxStyle={{ width: "130px", opacity: "", pointerEvents: "auto" }}
          variant="outlined"
          value={valuesInputsProdutor?.cep}
          onChange={handleChange("cep", "CEP")}
        />
        <AppTextField
          label="Endereço"
          sxStyle={{ width: "220px", opacity: "", pointerEvents: "auto" }}
          variant="outlined"
          value={valuesInputsProdutor?.endereco}
          onChange={handleChange("endereco")}
        />


        <AppTextField
          id="demo-simple-select"
          label="UF"
          sxStyle={{ width: "90px", opacity: "", pointerEvents: "auto" }}
          variant="outlined"
          value={valuesInputsProdutor?.estado}
          onChange={handleChange("estado") as never}
        >
          <MenuItem value=" " />
          {unidadesFederativas.map((item) => {
            return (
              <MenuItem key={item.sigla} value={item.sigla}>
                {item.nome}
              </MenuItem>
            );
          })}
        </AppTextField>

        <AppTextField
          label="Cidade"
          sxStyle={{ width: "170px", opacity: "", pointerEvents: "auto" }}
          variant="outlined"
          value={valuesInputsProdutor?.cidade}
          onChange={handleChange("cidade")}
        />
        <AppTextField
          label="Bairro"
          sxStyle={{ width: "170px", opacity: "", pointerEvents: "auto" }}
          variant="outlined"
          value={valuesInputsProdutor?.bairro}
          onChange={handleChange("bairro")}
        />

        <AppTextField
          label="Entrada"
          sxStyle={{ width: "150px", opacity: "", pointerEvents: "auto" }}
          variant="outlined"
          type="date"
          value={valuesInputsProdutor?.entrada}
          onChange={handleChange("entrada")}
        />
        <AppTextField
          label="Saída"
          sxStyle={{ width: "150px", opacity: "", pointerEvents: "auto" }}
          variant="outlined"
          type="date"
          value={valuesInputsProdutor?.saida}
          onChange={handleChange("saida")}
        />
        <AppTextField
          label="Observacoes"
          sxStyle={{ width: "180px", opacity: "", pointerEvents: "auto" }}
          variant="outlined"
          value={valuesInputsProdutor?.observacoes}
          onChange={handleChange("observacoes")}
        />
      </Box>

      <DividerCore title="Dados bancário" />

      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
        <AppTextField
          label="Pix"
          sxStyle={{ width: "170px", opacity: "", pointerEvents: "auto" }}
          variant="outlined"
          value={valuesInputsProdutor?.pix}
          onChange={handleChange("pix")}
        />
        <AppTextField
          label="Banco"
          sxStyle={{ width: "90px", opacity: "", pointerEvents: "auto" }}
          variant="outlined"
          value={valuesInputsProdutor?.banco}
          onChange={handleChange("banco")}
        />
        <AppTextField
          label="Agência"
          sxStyle={{ width: "90px", opacity: "", pointerEvents: "auto" }}
          variant="outlined"
          value={valuesInputsProdutor?.agencia}
          onChange={handleChange("agencia")}
        />
        <AppTextField
          label="Conta"
          sxStyle={{ width: "140px", opacity: "", pointerEvents: "auto" }}
          variant="outlined"
          value={valuesInputsProdutor?.conta}
          onChange={handleChange("conta")}
        />
        <AppTextField
          label="Favorecido"
          sxStyle={{ width: "250px", opacity: "", pointerEvents: "auto" }}
          variant="outlined"
          value={valuesInputsProdutor?.favorecido}
          onChange={handleChange("favorecido")}
        />
      </Box>
    </>
  );
};
